import { themeConstants } from "./brandingOptions";

export const setFormValues = (stateObject) => {
  if (document.getElementById("brand.cssFilename")) {
    document.getElementById("brand.cssFilename").value =
      stateObject.themeCss !== "-"
        ? stateObject.themeCss
        : [stateObject.themePrimaryColour, stateObject.themeTextColour].join(
            "|",
          );
  }
  if (document.getElementById("chartColor")) {
    console.log(
      "themeCss",
      stateObject.themeCss,
      themeConstants[stateObject.themeCss],
    );
    document.getElementById("chartBgColor").value = "fffffe";
    document.getElementById("chartColor").value =
      stateObject.themeCss !== "-"
        ? themeConstants[stateObject.themeCss] || "AAAAAA"
        : stateObject.themePrimaryColour.substring(1);
  }
  if (document.getElementById("brand.buttonCssFilename")) {
    document.getElementById("brand.buttonCssFilename").value =
      stateObject.buttonCss !== "-"
        ? stateObject.buttonCss
        : [
            stateObject.navigationButtonColour,
            stateObject.navigationTextColour,
          ].join("|");
  }
  if (document.getElementById("brand.navCssFilename")) {
    document.getElementById("brand.navCssFilename").value =
      stateObject.navCss !== "-"
        ? stateObject.navCss
        : [
            stateObject.navigationBackgroundColour,
            stateObject.navigationBackgroundGradientColour,
            stateObject.navigationButtonActiveColour,
            stateObject.navigationButtonHoverColour,
          ].join("|");
  }
  if (document.getElementById("brand.headCssFilename")) {
    document.getElementById("brand.headCssFilename").value =
      stateObject.headerCss !== "-"
        ? stateObject.headerCss
        : [
            stateObject.headerPrimaryColour,
            stateObject.headerGradientColour,
          ].join("|");
  }
  if (document.getElementById("brand.sectionCssFilename")) {
    document.getElementById("brand.sectionCssFilename").value =
      stateObject.sectionCss !== "-"
        ? stateObject.sectionCss
        : [stateObject.sectionBackgroundColour, stateObject.sectionColour].join(
            "|",
          );
  }
};

export const getFormValues = () => {
  const existingOptions = {};
  const themeBrand = document.getElementById("brand.cssFilename")?.value || "|";
  if (themeBrand.indexOf(".css") > -1) {
    existingOptions.themeCss = themeBrand;
    existingOptions.themePrimaryColour = "";
    existingOptions.themeTextColour = "";
  } else {
    existingOptions.themeCss = "-";
    [existingOptions.themePrimaryColour, existingOptions.themeTextColour] =
      themeBrand.split("|");
  }

  const buttonBrand =
    document.getElementById("brand.buttonCssFilename")?.value || "|";
  if (buttonBrand.indexOf(".css") > -1) {
    existingOptions.buttonCss = buttonBrand;
    existingOptions.navigationButtonColour = "";
    existingOptions.navigationTextColour = "";
  } else {
    existingOptions.buttonCss = "-";
    [
      existingOptions.navigationButtonColour,
      existingOptions.navigationTextColour,
    ] = buttonBrand.split("|");
  }

  const navBrand =
    document.getElementById("brand.navCssFilename")?.value || "|";
  if (navBrand.indexOf(".css") > -1) {
    existingOptions.navCss = navBrand;
    existingOptions.navigationBackgroundColour = "";
    existingOptions.navigationBackgroundGradientColour = "";
    existingOptions.navigationButtonActiveColour = "";
    existingOptions.navigationButtonHoverColour = "";
  } else {
    existingOptions.navCss = "-";
    [
      existingOptions.navigationBackgroundColour,
      existingOptions.navigationBackgroundGradientColour,
      existingOptions.navigationButtonActiveColour,
      existingOptions.navigationButtonHoverColour,
    ] = navBrand.split("|");
  }

  const headerBrand =
    document.getElementById("brand.headCssFilename")?.value || "|";
  if (navBrand.indexOf(".css") > -1) {
    existingOptions.headerCss = headerBrand;
    existingOptions.headerPrimaryColour = "";
    existingOptions.headerGradientColour = "";
  } else {
    existingOptions.headerCss = "-";
    [
      existingOptions.headerPrimaryColour,
      existingOptions.headerGradientColour,
    ] = headerBrand.split("|");
  }

  const sectionBrand =
    document.getElementById("brand.sectionCssFilename")?.value || "|";
  if (sectionBrand.indexOf(".css") > -1) {
    existingOptions.sectionCss = sectionBrand;
    existingOptions.sectionBackgroundColour = "";
    existingOptions.sectionColour = "";
  } else {
    existingOptions.sectionCss = "-";
    [existingOptions.sectionBackgroundColour, existingOptions.sectionColour] =
      sectionBrand.split("|");
  }
  return existingOptions;
};

export const updateScreen = (stateObject) => {
  const baseUrl = "/_client/stylesheets/";
  const rootSelector = document.querySelector(":root");
  if (document.getElementById("themeCss")) {
    if (stateObject.themeCss !== "-") {
      document.getElementById("themeCss").href =
        `${baseUrl}${stateObject.themeCss}`;
    } else {
      document.getElementById("themeCss").href = `${baseUrl}theme-custom.css`;
      rootSelector.style.setProperty(
        "--theme-main-colour",
        stateObject.themePrimaryColour,
      );
      rootSelector.style.setProperty(
        "--theme-main-text-colour",
        stateObject.themeTextColour,
      );
    }
  }
  if (document.getElementById("buttonCss")) {
    if (stateObject.buttonCss !== "-") {
      document.getElementById("buttonCss").href =
        `${baseUrl}${stateObject.buttonCss}`;
    } else {
      document.getElementById("buttonCss").href = `${baseUrl}button-custom.css`;
      rootSelector.style.setProperty(
        "--button-background",
        stateObject.navigationButtonColour,
      );
      rootSelector.style.setProperty(
        "--button-text",
        stateObject.navigationTextColour,
      );
    }
  }
  if (document.getElementById("navCss")) {
    if (stateObject.navCss !== "-") {
      document.getElementById("navCss").href =
        `${baseUrl}${stateObject.navCss}`;
    } else {
      document.getElementById("navCss").href = `${baseUrl}nav-custom.css`;
      rootSelector.style.setProperty(
        "--nav-bg-colour-primary",
        stateObject.navigationBackgroundColour,
      );
      rootSelector.style.setProperty(
        "--nav-bg-colour-secondary",
        stateObject.navigationBackgroundGradientColour,
      );
      rootSelector.style.setProperty(
        "--nav-button-text-active",
        stateObject.navigationButtonActiveColour,
      );
      rootSelector.style.setProperty(
        "--nav-button-text-hover",
        stateObject.navigationButtonHoverColour,
      );
    }
  }
  if (document.getElementById("headCss")) {
    if (stateObject.headerCss !== "-") {
      document.getElementById("headCss").href =
        `${baseUrl}${stateObject.headerCss}`;
    } else {
      document.getElementById("headCss").href = `${baseUrl}head-custom.css`;
      rootSelector.style.setProperty(
        "--head-bg-colour-primary",
        stateObject.headerPrimaryColour,
      );
      rootSelector.style.setProperty(
        "--head-bg-colour-secondary",
        stateObject.headerGradientColour,
      );
    }
  }
  if (document.getElementById("sectionCss")) {
    if (stateObject.sectionCss !== "-") {
      document.getElementById("sectionCss").href =
        `${baseUrl}${stateObject.sectionCss}`;
    } else {
      document.getElementById("sectionCss").href =
        `${baseUrl}section-custom.css`;
      rootSelector.style.setProperty(
        "--section-background",
        stateObject.sectionBackgroundColour,
      );
      rootSelector.style.setProperty(
        "--section-colour",
        stateObject.sectionColour,
      );
    }
  }

  if (document.getElementById("brandingOverRide")) {
    document.getElementById("brandingOverRide").value =
      JSON.stringify(stateObject);
  }

  // logo stuff
  if (document.getElementById("noLogo")?.checked === true) {
    console.log("logo not checked");
    document.getElementById("imageFilename").value = "transparent.gif";
  } else {
    console.log("Changing logo");
    document.getElementById("imageFilename").value =
      document.getElementById("logoFile").value;
  }

  if (stateObject.navigationType === "vertical") {
    document.querySelector(".container").style.marginLeft = "55px";
    document.querySelector(":root").style.setProperty("--navHeight", 0);
  } else {
    document.querySelector(".container").style.marginLeft = "0px";
    document.querySelector(":root").style.setProperty("--navHeight", "auto");
  }
  window.setTimeout(window.reloadNavigation, 500);
};

export default () => {};
